import { useMutation } from "@tanstack/react-query";

import {
  type FetchResponseOfError,
  postAuthPasswordReset,
  type ResetPasswordCommand,
} from "Infrastructure/Api/Api";
import { ApiCallError, isErrorStatus } from "Infrastructure/Api/ApiUtils";

export function useResetPasswordMutation() {
  return useMutation({
    mutationFn: (request: ResetPasswordCommand) =>
      postAuthPasswordReset(request),
    onSuccess: (data) => {
      if (isErrorStatus(data)) {
        throw new ApiCallError(data as unknown as FetchResponseOfError);
      }
    },
  });
}
